export default "__VITE_ASSET__Cn0x_qVg__"